'use es6';

import { createSelector } from 'reselect';
import { basicSelector } from 'ContentEditorUI/redux/selectors/helpers';
export const getContentGroup = basicSelector(state => state.contentGroup);
export const getContentGroupItemLayoutId = createSelector([getContentGroup], contentGroup => contentGroup.get('itemLayoutId'));
export const getContentGroupItemTemplatePath = createSelector([getContentGroup], contentGroup => contentGroup.get('itemTemplatePath'));